import { PageMeta } from "@/components/shared/PageMeta"
import CatalogCard from "@/components/shared/CatalogCard"
import AddToCartButton from "@/features/checkout/AddToCartButton"
import PRODUCTS, { productSlugs } from "@/content/products"
import { getDisplayPrice, promotionFromActive } from "@/content/prices"
import { PAGE_SEO } from "@/lib/seo"
import { useActivePromotionForItem } from "@/features/promotions/ActivePromotionProvider"

const EAGER_IMAGE_COUNT = 3

function ProductCard({ slug, index }: { slug: (typeof productSlugs)[number]; index: number }): React.JSX.Element {
	const product = PRODUCTS[slug]
	const active = useActivePromotionForItem(product.id)
	const promo = promotionFromActive(active)
	const price = getDisplayPrice(product.price, promo, product.id)
	const hasFreeShipping = Boolean(active?.freeShipping && active.itemIds.includes(product.id))

	return (
		<CatalogCard
			href={`/productos/${slug}`}
			imageSrc={product.imageGallery}
			eager={index < EAGER_IMAGE_COUNT}
			title={product.name}
			subtitle={product.title}
			price={price}
			hasFreeShipping={hasFreeShipping}
			buyButton={
				<AddToCartButton
					cartItem={{ id: product.id, priceId: product.priceId, amount: 1 }}
					variant="default"
					size="sm"
					className="ml-auto shrink-0 cursor-pointer"
				/>
			}
		/>
	)
}

export default function ProductosPage(): React.JSX.Element {
	return (
		<>
			<PageMeta {...PAGE_SEO.productos} path="/productos" />
			<div className="mx-auto max-w-6xl px-4 py-12">
				<h1 className="mb-8 text-3xl font-bold">Productos</h1>
				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{productSlugs.map((slug, index) => (
						<ProductCard key={slug} slug={slug} index={index} />
					))}
				</div>
			</div>
		</>
	)
}
